module.exports = __webpack_public_path__ + "img/credit_card.e2a79a8a.png";